import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import SessionStorageUtils from 'utils/SessionStorageUtils';
import { SessionStorageKeys } from 'constants/sessionStorageKeys';

export const Home = () => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  const location = SessionStorageUtils.getData(SessionStorageKeys.LOCATION);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/auth', { replace: true });
    } else if (location) {
      if (location.admin) {
        navigate(`/panel`, { replace: true });
      } else {
        navigate(`/${location.transliteration}`, { replace: true });
      }
    } else {
      navigate('/locations/choose', { replace: true });
    }
  }, []);
};
